export const cogImageContext = require.context(
  '../assets/cogs',
  false,
  /\.png$/
);
export const gagImageContext = require.context(
  '../assets/gags',
  false,
  /\.png$/
);

export const getImageFromContext = (context, filename) => {
  if (!filename) return '';
  try {
    return context(`./${filename}`);
  } catch (error) {
    return '';
  }
};
